<template>
  <Documents
    :uploadUrl="uploadUrl"
    :data-documents="company.documents"
    title="Upload Company Documents"
    :extraFields="{ type: 'company' }"
  />
</template>
<script>
import Documents from "@/components/documents";
export default {
  components: { Documents },
  props: {
    company: { required: true },
  },
  computed: {
    uploadUrl() {
      return `api/v1/companies/${this.company.id}/documents`;
    },
  },
};
</script>
